var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "resportesserie" }, [
    _c(
      "div",
      { staticClass: "flex sm10 md10" },
      [
        _c(
          "FormFieldsContainer",
          [
            _c(
              "v-flex",
              { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
              [
                _c(
                  "v-flex",
                  { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
                  [
                    _c(
                      "v-flex",
                      { attrs: { sm3: "", md3: "" } },
                      [
                        _c("v-text-field", {
                          attrs: { label: _vm.formFields.requerimiento.label },
                          model: {
                            value: _vm.formFields.requerimiento.value,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.formFields.requerimiento,
                                "value",
                                $$v
                              )
                            },
                            expression: "formFields.requerimiento.value"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-flex",
                      { attrs: { sm3: "", md3: "" } },
                      [
                        _c("v-autocomplete", {
                          attrs: {
                            label: _vm.formFields.estado.label,
                            items: _vm.estadosList,
                            "item-text": "configvalor",
                            "item-value": "configid"
                          },
                          model: {
                            value: _vm.formFields.estado.value,
                            callback: function($$v) {
                              _vm.$set(_vm.formFields.estado, "value", $$v)
                            },
                            expression: "formFields.estado.value"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-flex",
                      { attrs: { sm3: "", md3: "" } },
                      [
                        _c("v-autocomplete", {
                          attrs: {
                            label: _vm.formFields.razonsocial.label,
                            items: _vm.mandanteList,
                            "item-text": "nombre",
                            "item-value": "rut"
                          },
                          model: {
                            value: _vm.formFields.razonsocial.value,
                            callback: function($$v) {
                              _vm.$set(_vm.formFields.razonsocial, "value", $$v)
                            },
                            expression: "formFields.razonsocial.value"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-flex",
                      { attrs: { sm3: "", md3: "" } },
                      [
                        _c("v-autocomplete", {
                          attrs: {
                            label: _vm.formFields.mandante.label,
                            items: _vm.mandanteList,
                            "item-text": "nombre",
                            "item-value": "rut"
                          },
                          model: {
                            value: _vm.formFields.mandante.value,
                            callback: function($$v) {
                              _vm.$set(_vm.formFields.mandante, "value", $$v)
                            },
                            expression: "formFields.mandante.value"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-flex",
                      { attrs: { sm3: "", md3: "" } },
                      [
                        _c("v-autocomplete", {
                          attrs: {
                            label: _vm.formFields.tipoeq.label,
                            items: _vm.equiposlist,
                            "item-text": "tipoeqname",
                            "item-value": "tipoeqid"
                          },
                          model: {
                            value: _vm.formFields.tipoeq.value,
                            callback: function($$v) {
                              _vm.$set(_vm.formFields.tipoeq, "value", $$v)
                            },
                            expression: "formFields.tipoeq.value"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-flex",
                      { attrs: { sm3: "", md3: "" } },
                      [
                        _c("v-text-field", {
                          attrs: { label: _vm.formFields.serieEq.label },
                          model: {
                            value: _vm.formFields.serieEq.value,
                            callback: function($$v) {
                              _vm.$set(_vm.formFields.serieEq, "value", $$v)
                            },
                            expression: "formFields.serieEq.value"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-flex",
                      { attrs: { sm3: "", md3: "" } },
                      [
                        _c("v-text-field", {
                          attrs: { label: _vm.formFields.epc.label },
                          model: {
                            value: _vm.formFields.epc.value,
                            callback: function($$v) {
                              _vm.$set(_vm.formFields.epc, "value", $$v)
                            },
                            expression: "formFields.epc.value"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-flex",
                      { attrs: { sm3: "", md3: "" } },
                      [
                        _c("v-text-field", {
                          attrs: { label: _vm.formFields.oc.label },
                          model: {
                            value: _vm.formFields.oc.value,
                            callback: function($$v) {
                              _vm.$set(_vm.formFields.oc, "value", $$v)
                            },
                            expression: "formFields.oc.value"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-flex",
                      { attrs: { sm3: "", md3: "" } },
                      [
                        _c("v-checkbox", {
                          attrs: { label: _vm.formFields.soc.label },
                          model: {
                            value: _vm.formFields.soc.value,
                            callback: function($$v) {
                              _vm.$set(_vm.formFields.soc, "value", $$v)
                            },
                            expression: "formFields.soc.value"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-flex",
                      { attrs: { sm3: "", md3: "" } },
                      [
                        _c("DatePicker", {
                          attrs: {
                            label: _vm.formFields.fechaInicio.label,
                            "error-messages": _vm.errors.collect(
                              _vm.formFields.fechaInicio.id
                            ),
                            id: _vm.formFields.fechaInicio.id,
                            max: _vm.today
                          },
                          model: {
                            value: _vm.formFields.fechaInicio.value,
                            callback: function($$v) {
                              _vm.$set(_vm.formFields.fechaInicio, "value", $$v)
                            },
                            expression: "formFields.fechaInicio.value"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-flex",
                      { attrs: { sm3: "", md3: "" } },
                      [
                        _c("DatePicker", {
                          attrs: {
                            label: _vm.formFields.fechaFin.label,
                            "error-messages": _vm.errors.collect(
                              _vm.formFields.fechaFin.id
                            ),
                            id: _vm.formFields.fechaFin.id,
                            max: _vm.today
                          },
                          model: {
                            value: _vm.formFields.fechaFin.value,
                            callback: function($$v) {
                              _vm.$set(_vm.formFields.fechaFin, "value", $$v)
                            },
                            expression: "formFields.fechaFin.value"
                          }
                        })
                      ],
                      1
                    ),
                    _c("v-flex", { attrs: { sm4: "", md4: "" } }, [
                      _c(
                        "div",
                        { staticClass: "text-sm-center botones-filtros" },
                        [
                          _c(
                            "v-btn",
                            { on: { click: _vm.handleBuscarClick } },
                            [
                              _c("v-icon", [_vm._v("search")]),
                              _vm._v("Filtrar\n              ")
                            ],
                            1
                          ),
                          _c(
                            "v-btn",
                            { on: { click: _vm.clearFilters } },
                            [
                              _c("v-icon", [_vm._v("clear")]),
                              _vm._v("Limpiar\n              ")
                            ],
                            1
                          ),
                          _c(
                            "v-btn",
                            {
                              attrs: { flat: "", small: "", color: "primary" },
                              on: { click: _vm.btn_exportar }
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "importExportBtnIcon" },
                                [_vm._v("cloud_download")]
                              ),
                              _vm._v("  \n                "),
                              _c(
                                "span",
                                { staticClass: "importExportBtnTexto" },
                                [_vm._v("Exportar"), _c("br"), _vm._v("CSV")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _c("div", {
              staticClass: "clearfix",
              staticStyle: { width: "100%" }
            })
          ],
          1
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "gridcard rounded-card" },
      [
        _c("MantenedorGrid", {
          attrs: {
            "grid-options": _vm.gridOptions,
            funcionalidadId: _vm.funcionalidad
          }
        })
      ],
      1
    ),
    _vm.showReporteGenerado
      ? _c("div", { staticClass: "wrap-evidencia" }, [
          _c("div", { staticClass: "modalEnvio", attrs: { id: "myModal2" } }, [
            _c("div", { staticClass: "modalEnvio-content" }, [
              _c(
                "div",
                [
                  _vm._m(0),
                  _c(
                    "div",
                    {
                      staticClass: "buttonClose buttonCloseEvidencia",
                      attrs: { align: "right" }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { flat: "", small: "", color: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.closeReporte()
                            }
                          }
                        },
                        [
                          _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                            _vm._v("close")
                          ]),
                          _vm._v("  \n              "),
                          _c("span", { staticClass: "importExportBtnTexto" }, [
                            _vm._v("Cerrar")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("v-flex", { attrs: { sm12: "", md12: "" } }, [
                    _c("div", { staticClass: "text-sm-center" }, [
                      _c("p", { staticStyle: { "margin-top": "40px" } }, [
                        _vm._v(_vm._s(_vm.texto_reporte))
                      ])
                    ]),
                    _c("div", { staticClass: "text-sm-center" }, [
                      _c(
                        "p",
                        { staticStyle: { "margin-top": "40px" } },
                        [
                          _vm._v(
                            "\n                Puede ver sus reportes en el menú\n                "
                          ),
                          _c(
                            "router-link",
                            {
                              staticStyle: {
                                cursor: "pointer",
                                "font-size": "13px"
                              },
                              attrs: {
                                "active-class": "router-link-active",
                                to: "/conecta-reportes"
                              }
                            },
                            [_vm._v("Informes")]
                          )
                        ],
                        1
                      )
                    ])
                  ])
                ],
                1
              )
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titleEvidencia" }, [
      _c("h2", { staticClass: "importExportBtnIcon" }, [
        _vm._v("Reporte Solicitado")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }